<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <ProgressBar v-if="!isLiteView()" />
    <template v-if="isDataLoaded">
      <PageHeading
        v-if="isPrimaryUser"
        default-heading="Your account is almost ready"
      />
      <PageHeading
        v-if="!isPrimaryUser"
        default-heading="Thank you for signing"
      />
      <form
        @submit.prevent
      >
        <div v-if="!isPrimaryUser" class="pvd-container container-divider">
            <h2 class="pvd-heading-L">
              What’s next?
            </h2>
            <p>
              Your signature has been sent to the primary trustee. They'll finish opening the account
              once all signatures from additional trustees have been received.
            </p>
        </div>
        <div
          v-if="isPrimaryUser"
          class="pvd-container container-divider"
        >
          <p>
            Before we can open your account, all documents must be signed by all parties. We've
            sent emails on your behalf to all trustees asking for their signatures. Once we have
            them, we'll notify you to complete the application.
            <b>You must return and submit the application to complete it.</b>
            You can track the signatures on the next screen.
          </p>
        </div>
        <PageNavigation
          v-if="isPrimaryUser"
          primary-button-type="button"
          :show-primary-button-spinner="shouldShowLoadingSpinner"
          :disable-primary-button="shouldDisableNext"
          :primary-button-label="primaryButtonLabel"
          show-secondary-button="N"
          :page-exit-url="computedExitUrl"
          @primary-button-clicked="nextButtonClicked"
        />
        <PageNavigation
          v-if="!isPrimaryUser"
          primary-button-type="button"
          primary-button-label="Done"
          show-secondary-button="N"
          page-exit-url="https://www.fidelity.com"
          @primary-button-clicked="doneButtonClicked"
        />
      </form>
    </template>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import PageNavigation from '../components/PageNavigation.vue';
import pageNavigationHelper from '../mixins/pageNavigationHelper';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';

export default {
  name: 'TrustRetrievePage',
  components: {
    PageHeading,
    ProgressBar,
    PageNavigation,
  },
  mixins: [dataHelper, measurement, utility, pageNavigationHelper],
  data() {
    return {
      primaryButtonText: 'Next',
      backButtonAttempt: false,
      isLoading: false,
    };
  },
  computed: {
    isDataLoaded() {
      // Check if ectaSignInfo has been loaded
      const ectaSignInfo = this.getInstanceData()?.formData?.ectaSignInfo;
      return ectaSignInfo !== undefined && ectaSignInfo !== null;
    },
    isPrimaryUser() {
      return this.getInstanceData()?.formData?.ectaSignInfo
        ? this.getInstanceData().formData.ectaSignInfo?.isPrimaryUser : false;
    },
    shouldDisableNext() {
      return this.isLoading ? 'Y' : 'N';
    },
    shouldShowLoadingSpinner() {
      return this.isLoading ? 'Y' : 'N';
    },
    primaryButtonLabel() {
      if (this.pd_content && this.pd_content.primary_button && this.pd_content.primary_button.default) {
        return this.pd_content.primary_button.default;
      }
      return this.primaryButtonText;
    },
  },
  mounted() {
    this.track(this.cs_stateName, 'pageview');
    document.title = this.setTitle('Your account is almost ready');
    // Configure back button functionality
    const backButtonWarning = this.pd_content && this.pd_content.back_button_disabled_warning
      ? this.pd_content.back_button_disabled_warning : '';
    this.configureBackButtonFunctionality(() => this.showBackWarning(backButtonWarning));
    this.isLoading = false;
  },

  methods: {
    nextButtonClicked() {
      this.isLoading = true;
      this.performNavigation('next');
    },
    doneButtonClicked() {
      window.location.href = 'https://www.fidelity.com';
    },
  },
};
</script>

<style scoped>

</style>
